import { Modal, Button, Container, Row } from "react-bootstrap";
import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ReviewBusinessForm from "../../components/Business/ReviewBusinessForm";
import businessService from "../../services/businessService";
import { GlobalContext } from "../../utility/GlobalContext";
import ListReviews from "../../components/common/ListReviews";
import reviewService from "../../services/reviewService";
import userService from "../../services/userService";
import businessIcon from "../../assets/images/business-icon.png";

export default function BusinessPage(props) {
  const { state, setState } = useContext(GlobalContext);
  const businessID = useParams().id;
  const [business, setBusiness] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    fetchUser();
  }, [state.jwt]);

  useEffect(() => {
    fetchBusiness();
    fetchReviews();
  }, [businessID]);

  const fetchUser = () => {
    console.log("FETCH DAT");
    if (!state.jwt) {
      return;
    }
    userService
      .fetchSelf(state.jwt)
      .then((response) => {
        setState({ ...state, user: response.data });
      })
      .catch((err) => {
        // toast.error(err.response.data.msg || "Error occurred")
      });
  };

  const fetchReviews = () => {
    reviewService
      .list(businessID, "business")
      .then((response) => {
        console.log("Reviews: ", response.data);
        setReviews(response.data);
      })
      .catch((err) => {
        toast.error(err.response.data.msg || "Error occurred");
      });
  };

  const reset = () => {
    fetchBusiness();
    fetchReviews();
    setShowModal(false);
  };

  const fetchBusiness = () => {
    businessService
      .fetch(businessID)
      .then((response) => {
        console.log(response.data);
        setBusiness(response.data);
      })
      .catch((err) => {
        toast.error(err.response.data.msg || "Error occurred");
      });
  };
  const claimText = () => {
    if (business.status === "claimed") {
      return "Claimed by verified business ✅";
    }
    if (business.status === "pending") {
      return "Pending verification ⏳";
    }

    if (business.status === "unclaimed") {
      return "Unclaimed -- sign up and claim if you own it!";
    }
  };
  return (
    <Container>
      <Row>
        <img src={businessIcon} />
        <h2 style={{ marginTop: 7 }}>{business && business.name}</h2>
      </Row>
      <a target="_blank" href={`https://${business.link}`}>
        {business && `https://${business.link}`}
      </a>
      <p>{claimText()}</p>
      {state.user && state.user.type === "creator" && (
        <div>
          <Button onClick={() => setShowModal(true)}>Write Review</Button>
          <Modal
            onHide={() => setShowModal(false)}
            dialogClassName="my-modal"
            show={showModal}
          >
            <ReviewBusinessForm
              jwt={state.jwt}
              currentUserID={state.currentUserID}
              business={business}
              onReviewSucceeded={reset}
            />
          </Modal>
        </div>
      )}
      <hr></hr>
      <div>
        <h3>Reviews:</h3>
        <ListReviews reviews={reviews} business={business} />
      </div>
    </Container>
  );
}
